import request from '@/utils/request'

// api地址
const api = {
  all: '/frm/activityReg',
  save: '/frm/activityReg',
  update: '/frm/activityReg/update',
  delete: '/frm/activityReg/',
  deleteBatch: '/frm/activityReg/batch',
  page: '/frm/activityReg/page',
  export: '/frm/activityReg/export/',
  cancel: '/frm/activityReg/cancel',
  import: '/frm/activityReg/import/',
}

/**
 * 查询所有
 * @param params 参数
 * @returns {Promise<Array>}
 */
export function all(params) {
  return new Promise((resolve, reject) => {
    request.get(api.all, {
      params: params
    }).then(res => {
      resolve(res.data)
    }).catch(e => {
      reject(e)
    })
  })
}

/**
 * 查询列表
 * @param params 参数
 * @returns {Promise<Array>}
 */
export function page(params) {
  return new Promise((resolve, reject) => {
    request.get(api.page, {
      params: params
    }).then(res => {
      resolve(res.data)
    }).catch(e => {
      reject(e)
    })
  })
}
/**
 * 添加或修改
 * @param data 参数
 * @returns {Promise<>}
 */
export function save(data, isUpdate) {
  if (isUpdate) {
    return new Promise((resolve, reject) => {
      request.post(api.update, data).then(res => {
        resolve(res.data)
      }).catch(e => {
        reject(e)
      })
    })
  } else {
    return new Promise((resolve, reject) => {
      request.post(api.save, data).then(res => {
        resolve(res.data)
      }).catch(e => {
        reject(e)
      })
    })
  }
}
/**
 * 根据id删除
 * @param id id
 * @returns {Promise<>}
 */
export function deleteById(id) {
  return new Promise((resolve, reject) => {
    request.delete(api.delete + id).then(res => {
      resolve(res.data)
    }).catch(e => {
      reject(e)
    })
  })
}

/**
 * 批量删除
 * @param id id
 * @returns {Promise<>}
 */
export function deleteBatch(data) {
  return new Promise((resolve, reject) => {
    request.delete(api.deleteBatch, data).then(res => {
      resolve(res.data)
    }).catch(e => {
      reject(e)
    })
  })
}

/**
 * 导出活动用户信息
 * @param params 参数
 * @returns {Promise<Array>}
 */
export function exportActivityUserReg(id, params) {
  return new Promise((resolve, reject) => {
    request.get(api.export + id, {
      params: params,
      responseType: 'blob'
    }).then(res => {
      resolve(res)
    }).catch(e => {
      reject(e)
    })
  })
}
/**
 * 添加或修改
 * @param data 参数
 * @returns {Promise<>}
 */
export function cancel(data) {
  return new Promise((resolve, reject) => {
    request.post(api.cancel, data).then(res => {
      resolve(res.data)
    }).catch(e => {
      reject(e)
    })
  })
}
/**
 * 导入
 * @param data 参数
 * @returns {Promise<>}
 */
export function importRegLog(id, data) {
  return new Promise((resolve, reject) => {
    request.post(api.import + id, data, {
      'content-type': 'multipart/form-data'
    }).then(res => {
      resolve(res.data)
    }).catch(e => {
      reject(e)
    })
  })
}